// SizePicker - S47.1 / S48.2b.
// Selector del tamano de etiqueta. Wrapper de XLSelect con las opciones
// declaradas en constants.LABEL_SIZES, agrupadas visualmente por familia.
// S48.2b: prop opcional `disabled` para modo factura (no rompe llamadas
// existentes que omiten la prop).
import { useEffect, useMemo } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLSelect from '../../../components/xl/XLSelect';
import { LABEL_SIZES } from '../constants';

const CSS_ID = 'xl-et-sizepicker-css';
const CSS = `
.xl-et-sizepicker { display: inline-flex; flex-direction: column; gap: 4px; min-width: 280px }
.xl-et-sizepicker__hint {
  font: 500 11px/1.4 var(--xl-font-sans);
  color: var(--xl-color-text-muted);
}
`;

export default function SizePicker({ value, onChange, disabled }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const options = useMemo(() => {
    const avery = LABEL_SIZES.filter((s) => s.family === 'avery');
    const therm = LABEL_SIZES.filter((s) => s.family === 'thermal');
    const opts = [];
    avery.forEach((s) => opts.push({ value: s.id, label: s.label }));
    therm.forEach((s) => opts.push({ value: s.id, label: s.label }));
    return opts;
  }, []);

  const handle = (e) => {
    if (typeof onChange === 'function') onChange(e.target.value);
  };

  return (
    <label className="xl-et-sizepicker">
      <span className="xl-et-sizepicker__hint">Tamano de etiqueta</span>
      <XLSelect
        value={value}
        onChange={handle}
        options={options}
        disabled={!!disabled}
        ariaLabel="Tamano de etiqueta"
      />
    </label>
  );
}
